import React  from 'react'
import DropDown from '../dropdown';
import { TransactionCode } from '../../../api/services/next';

const TransactionsDropDown = ({...rest}) => {
    const sortByDisplayOrder = (data) => {
        return data.sort((a,b) => !b.DisplayOrder? -1: a.DisplayOrder < b.DisplayOrder? -1: 1)
    }
    return <DropDown sort={sortByDisplayOrder} search api={TransactionCode.GetTransactionCode} textField="Name" valueField="Id"  {...rest}/> 
}

export default TransactionsDropDown